import { type ComponentType } from 'react';
import { type z } from 'zod';

import { type api } from 'common';

import { type CodeMirrorLanguageType } from '../../Code/types';
import { type ProducedType } from '../types';

export type FlowBlockConfig = api.FlowDefinition.FlowBlock['config'];
export interface NodeHandleProps {
  type: 'source' | 'target';
  id?: string;
  handleName?: string;
  nameWrapVariant?: NodeHandleNameOverflowVariant;
}

export enum NodeHandleNameOverflowVariant {
  Wrap = 'Wrap',
  Ellipsis = 'Ellipsis',
}

export interface OutputContentProps<T extends keyof api.FlowDefinition.ProducedTypeMap> {
  returnValue: api.FlowDefinition.ProducedTypeMap[T] | undefined;
  metadata: unknown;
  isFullHeightView: boolean;
}

export interface BlockConfigProps<T extends FlowBlockConfig = FlowBlockConfig> {
  defaultLabelPrefix: string;
  defaultConfig: T;
  nodeHandles: NodeHandleProps[] | ((config: T) => NodeHandleProps[]);
  /**
   * configFields is used for configuring a configuration form within a form context wrapper
   */
  configFields:
    | {
        schema: z.ZodSchema;
        getLanguageFieldValues?: (
          config: T
        ) => Partial<Record<CodeMirrorLanguageType, (string | undefined)[]>>;
        FormFields: ComponentType;
      }
    | undefined;
  BlockContent?: ComponentType;
  returnType?: ProducedType;
  mockDataType?: 'string' | 'json' | 'none' | ((config: T) => 'string' | 'json' | 'none'); // json is the default if not specified
  documentationMarkdown:
    | string
    /**
     * React Component is limited to a small subset of components. Specifically, Skills.
     * Most documentation needs to follow the standard string pattern, which will automatically add a link to
     * our documentation site.
     */
    | ComponentType<{ config: T }>;
  OutputContentComponent?: ComponentType<OutputContentProps<any>>;
}
